<template>
    <section class="no-notification">
        <div class="container">
            <div class="no-notification-icon text-center">
                <img :src="mergedNoDataBody.image" alt="no-data-img">
            </div>
            <div class="thm-heading notification-text">
                <h3 class="profit-color text-capitalize">{{mergedNoDataBody.header}}</h3>
                <p class="text-capitalize">{{mergedNoDataBody.message}}</p>
            </div>
            <!-- <div class="thm-heading mt-lg-4 mt-2 data-btn">
                <a  class="thm-but ">Go back </a>
            </div> -->
        </div>
    </section>
</template>

<script>
export default {
    name: "NoDataFound",
    props: {
        noDataBody: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        mergedNoDataBody() {
            return {
                image: require("@/assets/images/no-data-img.svg"),
                header: "No Data Found!",
                message: "We can't find any item matching your search.",
                ...this.noDataBody
            };
        }
    }
}
</script>